module.exports = __webpack_public_path__ + "static/media/10.Crowd aww.1c0279fe.mp3";